/**
 * Desk JSON cache reset helpers — keep React state and commit refs in sync.
 *
 * Prefetch / active-tab loads read `dataByKeyRef` / `loadFailedByKeyRef` first.
 * Clearing only `useState` on deal switch leaves refs holding the prior deal's
 * payloads, so commitDeskJson rejects fresh fetches (`!replace && current[key]`)
 * and empty tabs stick. Always reset refs + state together.
 */

/** Empty maps for desk JSON + sticky failure caches. */
export function emptyDeskJsonCaches() {
  return { dataByKey: {}, loadFailedByKey: {} };
}

/**
 * Reset commit refs to empty caches (mutates refs in place).
 * @param {{ current: Record<string, unknown> }} dataByKeyRef
 * @param {{ current: Record<string, unknown> }} loadFailedByKeyRef
 */
export function resetDeskJsonCacheRefs(dataByKeyRef, loadFailedByKeyRef) {
  const empty = emptyDeskJsonCaches();
  dataByKeyRef.current = empty.dataByKey;
  loadFailedByKeyRef.current = empty.loadFailedByKey;
  return empty;
}

/**
 * Full desk shell reset payload (package + overview settle + sticky load UI).
 * Callers apply via setState; pair with resetDeskJsonCacheRefs.
 */
export function deskShellResetState() {
  return {
    ...emptyDeskJsonCaches(),
    dealPackage: null,
    dealPackageFailed: false,
    overviewExtrasReady: false,
    error: null,
    loading: false,
  };
}
